import type { FC } from "react"

import { studioToScreen } from "@logic/lib/design"
import type { Node2d, Edge2dComputed } from "@logic/lib/mesh"
import { useRecoilValue } from "recoil"

import { zoomState } from "~/containers/LegacyDesigner/state/view"
import { getRainbow } from "~/utils/getRainbow"

export const RainbowNodeEdgePairs: FC<{
  pairs: { node: Node2d; edge: Edge2dComputed }[]
}> = ({ pairs }) => {
  const zoom = useRecoilValue(zoomState)

  return (
    <>
      {pairs.map(({ node, edge }, i, { length }) => {
        const color = getRainbow(i)
        const r = (length - i + 1) * 3
        const opacity = (90 - r * 2) / 100
        const p0 = studioToScreen.point(node, zoom)
        const p1 = studioToScreen.point(edge.p1, zoom)
        const p2 = studioToScreen.point(edge.p2, zoom)

        return (
          <g key={JSON.stringify(r) + i}>
            <circle
              cx={p0.x}
              cy={p0.y}
              r={r}
              fill={color}
              opacity={opacity}
              stroke="black"
              strokeWidth={1}
            />
            <line
              x1={p1.x}
              y1={p1.y}
              x2={p2.x}
              y2={p2.y}
              stroke={color}
              strokeWidth={r}
              strokeDasharray="10, 10"
              opacity={opacity}
            />
          </g>
        )
      })}
    </>
  )
}
